var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLensesLeftWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2842_5907",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 14,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.709 0.446289H24.5999V25.0163H11.709V0.446289Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2842_5907)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1559 24.1808C15.9247 23.0548 14.2598 18.1901 14.2598 12.7321C14.2598 7.21435 15.895 2.4213 18.1559 1.28338C20.3457 2.3885 22.0499 7.18364 22.0499 12.7321C22.0499 18.2806 20.3457 23.0747 18.1559 24.1808ZM19.112 0.446289H17.1969C14.1194 0.446289 11.709 5.84259 11.709 12.7318C11.709 19.6209 14.1194 25.0163 17.1969 25.0163H19.112C22.1895 25.0163 24.5999 19.6209 24.5999 12.7318C24.5999 5.84259 22.1895 0.446289 19.112 0.446289Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.154 1.28347C17.8995 1.15428 17.6376 1.07477 17.3714 1.05191C17.3131 1.04595 17.2547 1.04297 17.1953 1.04297C14.5654 1.04297 12.3438 6.39564 12.3438 12.7322C12.3438 19.0677 14.5654 24.4205 17.1953 24.4205C17.2558 24.4205 17.3162 24.4174 17.3756 24.4105C17.6407 24.3876 17.9006 24.3091 18.154 24.1809C20.3439 23.0749 22.048 18.2806 22.048 12.7322C22.048 7.18374 20.3439 2.38859 18.154 1.28347Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2842_5907",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 12,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60938 0.446289H17.5171V25.0163H6.60938V0.446289Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2842_5907)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0643 24.1808C10.1764 23.0548 8.76758 18.1901 8.76758 12.7321C8.76758 7.21435 10.1512 2.4213 12.0643 1.28338C13.9172 2.3885 15.3592 7.18364 15.3592 12.7321C15.3592 18.2806 13.9172 23.0747 12.0643 24.1808ZM12.8735 0.446289H11.253C8.64896 0.446289 6.60938 5.84259 6.60938 12.7318C6.60938 19.6209 8.64896 25.0163 11.253 25.0163H12.8735C15.4775 25.0163 17.5171 19.6209 17.5171 12.7318C17.5171 5.84259 15.4775 0.446289 12.8735 0.446289Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0629 1.28347C11.8475 1.15428 11.6259 1.07477 11.4006 1.05191C11.3513 1.04595 11.3019 1.04297 11.2517 1.04297C9.02635 1.04297 7.14648 6.39564 7.14648 12.7322C7.14648 19.0677 9.02635 24.4205 11.2517 24.4205C11.3028 24.4205 11.354 24.4174 11.4042 24.4105C11.6286 24.3876 11.8484 24.3091 12.0629 24.1809C13.9158 23.0749 15.3578 18.2806 15.3578 12.7322C15.3578 7.18374 13.9158 2.38859 12.0629 1.28347Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2842_5907",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 26
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.492188 0.446289H11.3999V25.0163H0.492188V0.446289Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2842_5907)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94711 24.1808C4.05917 23.0548 2.65039 18.1901 2.65039 12.7321C2.65039 7.21435 4.03404 2.4213 5.94711 1.28338C7.80006 2.3885 9.24204 7.18364 9.24204 12.7321C9.24204 18.2806 7.80006 23.0747 5.94711 24.1808ZM6.75632 0.446289H5.13578C2.53178 0.446289 0.492188 5.84259 0.492188 12.7318C0.492188 19.6209 2.53178 25.0163 5.13578 25.0163H6.75632C9.36032 25.0163 11.3999 19.6209 11.3999 12.7318C11.3999 5.84259 9.36032 0.446289 6.75632 0.446289Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94566 1.28347C5.73031 1.15428 5.50867 1.07477 5.28345 1.05191C5.2341 1.04595 5.18474 1.04297 5.1345 1.04297C2.90916 1.04297 1.0293 6.39564 1.0293 12.7322C1.0293 19.0677 2.90916 24.4205 5.1345 24.4205C5.18564 24.4205 5.23679 24.4174 5.28704 24.4105C5.51137 24.3876 5.73121 24.3091 5.94566 24.1809C7.79861 23.0749 9.24059 18.2806 9.24059 12.7322C9.24059 7.18374 7.79861 2.38859 5.94566 1.28347Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLensesLeftWhite);
export default __webpack_public_path__ + "static/media/lenses-left-white.2b4e61de771fbf7a75d75d1a4a99779e.svg";
export { ForwardRef as ReactComponent };